<template>
  <div style="width:100%;height:100%">
    <div class="toolbar mw-toolbar">
          <el-radio v-model="serverPort" label="8878" border>本机本机</el-radio>
          <el-radio v-model="serverPort" label="8877" border>全部日志</el-radio>
          <el-button type="primary" @click="connect">连接</el-button>
          <el-button type="warning" @click="clear">清空</el-button>
          <el-button type="danger" @click="close">断开连接</el-button>
    </div>
    <div class="server-log" style="height:calc(100% - 60px);width:100%;background:#555;color:white;overflow:auto;" ref='container'>

    </div>
</div>
</template>
<script>
export default {
    name: 'MwServiceConsole',
  components: {

  },
  data() {
    let me = this;
    return {
      serverPort:"8878"
    };
  },
  methods: {
    connect:function(){
          var me=this;
          var port = this.serverPort || '8878';
          var url = 'ws://' + window.location.hostname + ':' + port;
          if(me.ws)
          {
              me.ws.close();
          }
          me.ws = new WebSocket(url);
          me.ws.onmessage = function (e)
          {
              var node = document.createElement('PRE');
              node.innerHTML = e.data;
              var container=me.$refs.container;
              container.appendChild(node);
              container.scrollTop = container.scrollHeight;
          }
      },
      clear:function(){
          this.$refs.container.innerHTML="";
      },
      close:function(){
          if(this.ws)this.ws.close();
      },
      destroyed:function(){
          this.close()
      }
  },
  watch: {}
};
</script>
<style >
.server-log pre {
    background: #555;
    color: white;
    border: none;
    word-break: normal;
    white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/modules/index/components/service-edit/serviceConsole.vue